// extracted by mini-css-extract-plugin
module.exports = {"chartContainerBackground":"ProfileAttributesMetrics_chartContainerBackground__1F5ek","loadingContainer":"ProfileAttributesMetrics_loadingContainer__2xV_1"};